/* eslint-disable no-template-curly-in-string */
import React, { PureComponent, useContext } from 'react';
import { Form } from 'antd';

const defaultValidateMessages = {
  required: '${label} é obrigatório'
};

const Context = React.createContext({ form: null });

class FormManager extends PureComponent {
  static useForm;

  static FormItem;

  render() {
    let values = {};

    const {
      children,
      form,
      initialValues = {},
      onBeforeBinding,
      ...rest
    } = this.props;

    if (onBeforeBinding) {
      values = onBeforeBinding(initialValues);
    }

    return (
      <Context.Provider value={{ form }}>
        <Form
          {...rest}
          form={form}
          validateMessages={defaultValidateMessages}
          initialValues={values}
        >
          {children}
        </Form>
      </Context.Provider>
    );
  }
}

FormManager.useForm = () => {
  const { form } = useContext(Context);

  if (!form) {
    throw new Error('Missing FormManager in its parent.');
  }

  return form;
};

FormManager.FormItem = ({
  children,
  label,
  required,
  message,
  rules,
  ...rest
}) => {
  let defaultRules;

  if (required) {
    defaultRules = [{ required }];
  }

  return (
    <Form.Item label={label} rules={rules || defaultRules} {...rest}>
      {children}
    </Form.Item>
  );
};

export default FormManager;
